import dashboardService from '../services/dashboardService';
import {
  FETCH_DASHBOARD,
  FETCH_GRAFICAS_FAVORITAS,
  FETCH_CONTADORES,
  FETCH_ULTIMOS_SENSORES,
  FETCH_CONSUMO_ENERGIA,
  TOGGLE_FAVORITE_GRAFICA,
  SET_DASHBOARD_LOADING,
  SET_DASHBOARD_ERROR
} from './types';

// Action creators
export const fetchDashboard = () => ({
  type: FETCH_DASHBOARD,
  promise: dashboardService.getDashboard()
});

export const fetchGraficasFavoritas = () => ({
  type: FETCH_GRAFICAS_FAVORITAS,
  promise: dashboardService.getGraficasFavoritas()
});

export const fetchContadores = () => ({
  type: FETCH_CONTADORES,
  promise: dashboardService.getContadores()
});

export const fetchUltimosSensores = () => ({
  type: FETCH_ULTIMOS_SENSORES,
  promise: dashboardService.getUltimosSensores()
});

export const fetchConsumoEnergia = () => ({
  type: FETCH_CONSUMO_ENERGIA,
  promise: dashboardService.getConsumoEnergia()
});

export const toggleFavoriteGrafica = (id, favorita) => ({
  type: TOGGLE_FAVORITE_GRAFICA,
  promise: dashboardService.toggleFavoriteGrafica(id, favorita),
  meta: { id, favorita }
});

export const setDashboardLoading = (loading) => ({
  type: SET_DASHBOARD_LOADING,
  payload: loading
});

export const setDashboardError = (error) => ({
  type: SET_DASHBOARD_ERROR,
  payload: error
});
